<template>
  <v-container v-if="DataProcesos !== null" grid-list-xl>
    <div class="vue-contentido">
      <v-divider></v-divider>

      <v-layout row wrap>
        <v-card :elevation="2" :loading="loading" :disabled="loading">
          <v-card-title>Procesos pendientes</v-card-title>
          <v-card-text active-class="deep-purple accent-4 white--text">
            <v-flex xs12 sm12>
              <v-data-table
                :headers="headerprocesos"
                :items="DataProcesos"
                class="elevation-1"
                :no-data-text="gnodata"
                :items-per-page="5"
              >
              <template #[`item.fulldate`]="{ item }">{{ item.diaejecucion }} {{ item.horaejecucion }}</template>
                <template v-slot:[`item.action`]="{ item }">
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        small
                        class="mr-2"
                        v-scroll-to="'#containera'"
                        @click="grideditProcess(item)"
                        >edit</v-icon
                      >
                    </template>
                    <span>Editar</span>
                  </v-tooltip>
                </template>
              </v-data-table>
              <v-divider></v-divider>
            </v-flex>
          </v-card-text>

          <v-card v-show="frameprocesos" id="containera" ref="containera" color="#EEEEEE">
            <v-card-text>
                {{Editedproceso.nombreProceso}}
                <v-flex row wrap>
                    <v-flex sm5 xs12>
                      <v-menu
                          ref="menu1" v-model="menuPicker" :close-on-content-click="false" :return-value.sync="Editedproceso.diaejecucion"
                          transition="scale-transition" offset-y min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-combobox v-model="Editedproceso.diaejecucion"  prepend-icon="mdi-calendar"
                              readonly v-bind="attrs" v-on="on" label="Fecha de Ejecución: *"
                            >
                            		<template v-slot:item="{ item }">
                                  <span>{{ item.diaejecucion }}</span>
                                </template>
                            </v-combobox>
                          </template>
                          <v-date-picker v-model="Editedproceso.diaejecucion" no-title scrollable >
                            <v-spacer></v-spacer>
                            <v-btn text color="primary" @click="menuPicker = false" > Cancel </v-btn>
                            <v-btn text color="primary" @click="$refs.menu1.save(Editedproceso.diaejecucion)" > OK </v-btn>
                          </v-date-picker>
                        </v-menu>
                    </v-flex>
                    <v-flex sm5 xs12>

                      <v-dialog
                        ref="dialog"
                        v-model="menuTimer"
                        :return-value.sync="Editedproceso.horaejecucion"
                        persistent
                        width="390px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="Editedproceso.horaejecucion"
                            label="Hora de ejecución: "
                            prepend-icon="mdi-clock-time-four-outline"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-time-picker
                          v-if="menuTimer"
                          v-model="Editedproceso.horaejecucion"
                          full-width
                          format="24hr"
                        >
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            color="primary"
                            @click="menuTimer = false"
                          >
                            Cancelar
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="$refs.dialog.save(Editedproceso.horaejecucion)"
                          >
                            Aceptar
                          </v-btn>
                        </v-time-picker>
                      </v-dialog> 


                    </v-flex>
                    <v-flex sm2 xs12>
                        <v-text-field
                          v-model="Editedproceso.diainicio"
                          label="Dia de Inicio:"
                          v-validate="'required|max:27'"
                          data-vv-name="rulediainicio"
                          :error-messages="errors.collect('rulediainicio')"
                        ></v-text-field>    
                    </v-flex>
                    <v-flex sm12 xs12>
                        Acciones del Proceso
                        <v-tabs show-arrows next-icon="fa-caret-right" prev-icon="fa-caret-left" background-color="blue-grey lighten-4" horizontal>
                            <v-tabs-slider></v-tabs-slider>
                            <v-tab >
                                <v-icon left>note_add</v-icon>Acciones Relacionadas
                            </v-tab>
                            <v-tab >
                              <v-icon left>description</v-icon>Tareas en Proceso
                            </v-tab>  

                            <v-tab-item> 
                                <v-data-table
                                  :headers="headeracciones"
                                  :items="DataAcciones"
                                  class="elevation-1"
                                  :no-data-text="gnodata"
                                  :items-per-page="5"
                                >
                                    <template v-slot:top>
                                      <v-dialog v-model="frameacciones" max-width="400px">
                                        <v-card>
                                          <v-card-text>
                                            <v-flex xs12 sm12 md12>
                                              <v-text-field
                                                v-model="EditedAcciones.dias"
                                                label="Dias"
                                                v-validate="'required'"
                                                data-vv-name="DiasAcciones"
                                                :error-messages="errors.collect('DiasAcciones')"
                                              ></v-text-field>
                                            </v-flex>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-btn color="blue darken-1" @click="closeAcciones"
                                              >Cancelar</v-btn
                                            >
                                            <v-btn
                                              color="blue darken-1"
                                              @click="saveAcciones"
                                              >Guardar</v-btn
                                            >
                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </template>                                
                                  <template v-slot:[`item.action`]="{ item }">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          small
                                          class="mr-2"
                                          @click="grideditAccion(item)"
                                          >edit</v-icon
                                        >
                                      </template>
                                      <span>Editar</span>
                                    </v-tooltip>          
                                  </template>
                                </v-data-table>                       
                            </v-tab-item>

                            <v-tab-item>     
                                <v-text-field
                                  v-model="searchtareas"
                                  append-icon="search"
                                  label="Buscar"
                                  single-line
                                  hide-details
                                  @keyup="filtrartareas"
                                ></v-text-field> 
                                <v-data-table
                                  :headers="headertareas"
                                  :items="tareas"
                                  class="elevation-1"
                                  :no-data-text="gnodata"
                                  :items-per-page="5"
                                >
                                <template v-slot:[`item.activoTarea`]="{ item }">
                                  <div v-if="item.activoTarea == true">
                                    verdadero
                                  </div>
                                  <div v-else>
                                    falso
                                  </div>
                                </template>
                                <template v-slot:[`item.codigoFlujo`]="{ item }">
                                  <div v-if="item.codigoFlujo !== null && item.codigoFlujo !== ''">
                                    <span small class="mr-2">{{item.codigoFlujo}}</span>
                                  </div>
                                  <div v-else>
                                    <span small class="mr-2">{{item.nombreFlujo}}</span>
                                  </div>
                                </template>
                                <template #[`item.fulldate`]="{ item }">{{ item.diaejecucion }} {{ item.horaejecucion }}</template>
                                    <template v-slot:top>
                                      <v-dialog v-model="frametareas" max-width="400px">
                                        <v-card>
                                          <v-card-text>
                                            <v-flex xs12 sm12 md12>
                                              
                                                <v-menu
                                                    ref="menu2" v-model="menuTareasPicker" :close-on-content-click="false" :return-value.sync="EditedTareas.diaejecucion"
                                                    transition="scale-transition" offset-y min-width="auto"
                                                  >
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-combobox v-model="EditedTareas.diaejecucion" prepend-icon="mdi-calendar"
                                                        readonly v-bind="attrs" v-on="on" label="Fecha de Ejecución: *"
                                                      ></v-combobox>
                                                    </template>
                                                    <v-date-picker v-model="EditedTareas.diaejecucion" no-title scrollable >
                                                      <v-spacer></v-spacer>
                                                      <v-btn text color="primary" @click="menuTareasPicker = false" > Cancel </v-btn>
                                                      <v-btn text color="primary" @click="$refs.menu2.save(EditedTareas.diaejecucion)" > OK </v-btn>
                                                    </v-date-picker>
                                                  </v-menu>                                          

                                                  <v-dialog
                                                    ref="dialog1"
                                                    v-model="menuTeareasTimer"
                                                    :return-value.sync="EditedTareas.horaejecucion"
                                                    persistent
                                                    width="390px"
                                                  >
                                                    <template v-slot:activator="{ on, attrs }">
                                                      <v-text-field
                                                        v-model="EditedTareas.horaejecucion"
                                                        label="Hora de ejecución: "
                                                        prepend-icon="mdi-clock-time-four-outline"
                                                        readonly
                                                        v-bind="attrs"
                                                        v-on="on"
                                                      ></v-text-field>
                                                    </template>
                                                    <v-time-picker
                                                      v-if="menuTeareasTimer"
                                                      v-model="EditedTareas.horaejecucion"
                                                      full-width
                                                      format="24hr"
                                                    >
                                                      <v-spacer></v-spacer>
                                                      <v-btn
                                                        text
                                                        color="primary"
                                                        @click="menuTeareasTimer = false"
                                                      >
                                                        Cancelar
                                                      </v-btn>
                                                      <v-btn
                                                        text
                                                        color="primary"
                                                        @click="$refs.dialog1.save(EditedTareas.horaejecucion)"
                                                      >
                                                        Aceptar
                                                      </v-btn>
                                                    </v-time-picker>
                                                  </v-dialog>                                                 

                                            </v-flex>
                                          </v-card-text>
                                          <v-card-actions>
                                            <v-btn color="blue darken-1" @click="CloseTareas"
                                              >Cancelar</v-btn
                                            >
                                            <v-btn
                                              color="blue darken-1"
                                              @click="saveTareas"
                                              >Guardar</v-btn
                                            >
                                            <v-btn
                                              color="blue darken-1"
                                              @click="saveTodasTareas"
                                              >Cambiar Todas</v-btn
                                            >

                                          </v-card-actions>
                                        </v-card>
                                      </v-dialog>
                                    </template>                                 
                                  <template v-slot:[`item.action`]="{ item }">
                                    <v-tooltip top>
                                      <template v-slot:activator="{ on }">
                                        <v-icon
                                          v-on="on"
                                          small
                                          class="mr-2"
                                          @click="grideditTarea(item)"
                                          >edit</v-icon
                                        >
                                      </template>
                                      <span>Editar</span>
                                    </v-tooltip>          
                                  </template>
                                </v-data-table>                                                      
                            </v-tab-item>
                        </v-tabs>


                    </v-flex>                                      
                </v-flex>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1"
                    v-on="on"
                    color="blue darken-1"
                    @click="closetemporizacion"
                  >
                    <div class="text-white">Cancelar</div>
                  </v-btn>
                </template>
                <span>Cancelar</span>
              </v-tooltip>

              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn
                    class="mx-1"
                    v-on="on"
                    color="blue darken-1"
                    @click="saveTemporizacion"
                  >
                    <div class="text-white">Guardar</div>
                  </v-btn>
                </template>
                <span>Guardar</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-card>
      </v-layout>
    </div>

    <v-snackbar
      v-model="snack"
      :timeout="timeoutsnak"
      :color="MesaggeInfo.color"
    >
      {{ this.MesaggeInfo.codigoRespuesta }}
      {{ this.MesaggeInfo.mensajeRespuesta }}
      
      
    </v-snackbar>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "admintemporizador",
  data() {
    return {
      //Datos de los procesos
      modal2: false,
      DataProcesos: [],
      Editedproceso: [],
      frameprocesos: false,
      Editarproceso: false,
      editedprocesoIndex: -1,
      menuPicker: false,
      menuTimer:false,
      Dateprocesos : '',
      Timeprocesos : '',
      headerprocesos: [
        {
          text: "ID",
          value: "idtemporizador",
          align: " d-none"
        },
        { text: "Fecha Ejecucion", value: "fulldate", align: "left", width: "200px" },
        { text: "Proceso", value: "nombreProceso", align: "left", width: "400px" },
        { text: "Dia inicio", value: "diainicio", align: "left", width: "100px" },
        { text: "Periodicidad en Meses", value: "periodicidadmensual", align: "left", width: "100px" },
        {
          text: "fechabloqueo",
          value: "fechabloqueo",
          align: "left",
          width: "100px",
        },
        { text: "Acciones", value: "action", sortable: false, width: "10px" }
      ],

      // Datos de las acciones de tiempos
      DataAcciones: [],
      EditedAcciones: [],
      frameacciones: false,
      Editaracciones: false,
      editedaccionIndex: -1,
      headeracciones: [
        {
          text: "ID",
          value: "idaccion",
          align: " d-none"
        },
        { text: "Campo", value: "campo", align: "left" },
        { text: "Dias", value: "dias", align: "left" },
        { text: "Espera", value: "espera", align: "left" },
        { text: "Actividad", value: "nombreAccion", align: "left" },
        { text: "Acciones", value: "action", sortable: false, width: "10px" }
      ],

      // Datos de las tareas
      searchtareas: "",
      tareas: [],
      DataTareas: [],
      EditedTareas: [],
      frametareas: false,
      menuTareasPicker: false,
      menuTeareasTimer: false,
      Editartareas: false,
      editedtaresIndex: -1,
      headertareas: [
        {
          text: "ID", value: "idtemporizador", align: " d-none"},
        { text: "Fecha Ejecucion", value: "fulldate", align: "left", width: "200px" },
        { text: "Proceso", value: "nombreProceso", align: "left" },
        { text: "Tarea", value: "nombreTarea", align: "left" },
        { text: "IDTarea", value: "Idtarea", align: " d-none"},
        { text: "Codigo", value: "codigoFlujo", align: "left" },
        { text: "Entidad", value: "entidadFlujo", align: "left" },
        { text: "Estado", value: "activoTarea", align: "left" },
        { text: "Acciones", value: "action", sortable: false, width: "10px" }
      ],      

      loading: false,

      //campos del cuadro de dialog de mensajes
      snack: false,
      snackalert: false,
      MesaggeInfo: [{ codigoRespuesta: "", color: "", mensajeRespuesta: "" }],
      timeoutsnak: 4000,
      buttontext: "cerrar",

      //Validacion de campos
      dictionary: {
        custom: {
            rulediainicio: {
                required: () => "El campo dia es obligatorio",
                numeric: "El campo es numerico",
            },
            DiasAcciones: {
                required: () => "El campo dia es obligatorio",
                numeric: "El campo es numerico",
            }
        },
      },
    };
  },
  methods: {
    ...mapActions([
      "get_procesostemporizador",
      "get_tareastemporizador",
      "get_accionestiempobyproceso",
      "putacciontiempo",
      "putTareaunica",
      "putTaremasiva",
      "putTemporizadoryproceso"
    ]),
    grideditProcess(item) {
      this.frameprocesos = true;
      this.Editarproceso = true;
      this.editedprocesoIndex = this.DataProcesos.indexOf(item);
      this.Editedproceso = Object.assign({}, item); 

      this.get_accionestiempobyproceso({
              params: {
                idproceso: this.Editedproceso.idprocesodesvio,
              },
            });
      this.get_tareastemporizador({
              params: {
                ejecutado: false,
                idproceso: this.Editedproceso.idprocesodesvio,
              },
            });
    
    },
    grideditAccion(item) {
        this.editedaccionIndex = this.DataAcciones.indexOf(item);
        this.EditedAcciones = Object.assign({}, item);
        this.frameacciones = true;
    },
    grideditTarea(item) {
        this.editedtaresIndex = this.DataTareas.indexOf(item);
        this.EditedTareas = Object.assign({}, item);
        this.frametareas = true;    
    },
    closeAcciones() {
      this.frameacciones = false;
    },
    CloseTareas(){ 
        this.frametareas = false;    
    },
    saveAcciones(){
        if (this.editedaccionIndex > -1) {
            Object.assign(
              this.DataAcciones[this.editedaccionIndex], this.EditedAcciones );
        this.putacciontiempo({
            data: this.EditedAcciones
          });
        }
        this.frameacciones = false;
    },
    saveTareas(){
        if (this.editedtaresIndex > -1) {
            this.EditedTareas.fechaejecucion = this.formatofechaVb(this.EditedTareas.diaejecucion + ' ' + this.EditedTareas.horaejecucion);
            Object.assign( this.DataTareas[this.editedtaresIndex], this.EditedTareas );
            this.putTareaunica({
                data: this.EditedTareas
            });
        }
        this.frametareas = false;
    },
    saveTodasTareas(){
        if (this.editedtaresIndex > -1) {
            let FechaNueva = this.formatofechaVb(this.EditedTareas.diaejecucion + ' ' + this.EditedTareas.horaejecucion);
            this.DataTareas.forEach(element => {
                element.fechaejecucion = FechaNueva;
                element.diaejecucion = this.EditedTareas.diaejecucion;
                element.horaejecucion = this.EditedTareas.horaejecucion;
            });
            this.putTaremasiva({
                data: this.DataTareas
            });
            
        }
        this.frametareas = false;
    },
    saveTemporizacion(){
        if (this.editedprocesoIndex > -1) {
            this.Editedproceso.fechaejecucion = this.formatofechaVb(this.Editedproceso.diaejecucion + ' ' + this.Editedproceso.horaejecucion);
            Object.assign( this.DataProcesos[this.editedprocesoIndex], this.Editedproceso );
            this.putTemporizadoryproceso({
                data: this.Editedproceso
            });
        }
        this.frameprocesos = false;
    },
    closetemporizacion(){
        this.frameprocesos = false;
    },
    formatofecha(value) {
      if (value) {
        return moment(String(value)).format("DD/MM/YYYY");
      }
    },
    formatofechaVb(value) {
      if (value) {
        return moment(String(value)).format("YYYY/MM/DD HH:mm:ss");
      }
    },
    filtrartareas() {
      if (this.searchtareas === "") {
        this.tareas = this.DataTareas;
      } else {
        this.tareas = this.DataTareas.filter(
          (p) =>
            p.codigoFlujo
              .toUpperCase()
              .indexOf(this.searchtareas.toUpperCase()) !== -1 
        );
      }
    },

  },
  created() {
    this.get_procesostemporizador({
              params: {
                ejecutado: false,
              },
            });

  },
  $_veeValidate: {
    validator: "new",
  },
  computed: {
    ...mapGetters(["gtemporizacionbyprocceso", "gtemporizacionbytareas", "gaccionestiempobyproceso"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata", "ginformation"]),

  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },

  watch: {
    gtemporizacionbyprocceso: function () {
      this.DataProcesos = this.gtemporizacionbyprocceso;
    },
    gaccionestiempobyproceso: function () {
        this.DataAcciones = this.gaccionestiempobyproceso;
    },
    gtemporizacionbytareas: function () {
        this.DataTareas = this.gtemporizacionbytareas;
        this.tareas = this.DataTareas;
    },
    ginformation() {  
      this.MesaggeInfo = this.ginformation;
      this.snack = true;
    },
  },
};
</script>